export function calculateReadingTime(blog_content: Array<{ type: string; text: string }>): number {
  let text = '';
  blog_content.map((component) => {
    if (component.type === 'textElement') {
      text += component.text;
    }
  });

  // Get the total word count
  const wordCount = text.split(/\s+/).length;

  // Calculate the estimated reading time
  const minutes = Math.ceil(wordCount / 200);

  // Return the estimated reading time as a rounded-up number of minutes
  return minutes;
}
